import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import GuideLanguageService from "../../../../services/catalogs/GuideLanguageService";

export const REQUEST_CREATE_GUIDE_LANGUAGE = "REQUEST_CREATE_GUIDE_LANGUAGE";
export const CREATE_GUIDE_LANGUAGE_SUCCESS = "CREATE_GUIDE_LANGUAGE_SUCCESS";
export const CREATE_GUIDE_LANGUAGE_ERROR = "CREATE_GUIDE_LANGUAGE_ERROR";

function requestCreateGuideLanguage() {
  return {
    type: REQUEST_CREATE_GUIDE_LANGUAGE,
  };
}

function createGuideLanguageSuccess(json) {
  return {
    type: CREATE_GUIDE_LANGUAGE_SUCCESS,
    message: json.data,
  };
}

function createGuideLanguageError(json) {
  return {
    type: CREATE_GUIDE_LANGUAGE_ERROR,
    error: json.data,
  };
}

export function createGuideLanguage(guide_id, payload) {
  return (dispatch) => {
    dispatch(requestCreateGuideLanguage());
    return GuideLanguageService.postGuideLanguage(guide_id, payload).then(
      (json) => {
        if (json.data.code === 200) {
          dispatch(createGuideLanguageSuccess(json.data));
        } else if (json.data.code === 202) {
          updateLocalStorageToken(json.data.token);
          dispatch(createGuideLanguage(guide_id, payload));
        } else if (json.data.code === 498) {
          logOut();
        } else {
          dispatch(createGuideLanguageError(json.data));
        }
      }
    );
  };
}
